import styled from "styled-components";

export const Wrapper = styled.div`
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
`;